// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../Assets/font/Maitree/Maitree-Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../Assets/font/Maitree/Maitree-Medium.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.my-patients-container {
    display: flex;
    background-color: var(--darkGreen);
}

.my-patients-container .my-patients-left-section {
    width: 15%;
}

.my-patients-container .my-patients-right-section {
    width: 85%;
    background-color: var(--lightBlack);
    border-radius: 20px 0px 0px 20px;
    padding: 23px 34px;
}

.my-patients-topbar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    border-bottom: 1px solid rgb(255, 255, 255, 50%);
    padding-bottom: 12px;
    gap: 0.5rem;
}

.my-patients-topbar .title {
    font-weight: 400;
    color: var(--primeryColor);
}

.my-patients-topbar .right {
    display: flex;
    align-items: center;
    margin-left: auto;
}

.list-icon {
    margin-left: 19px;
}

.btn-wrapper button.btn-small.only-icon-btn {
    padding: 0;
    background: var(--darkGreen);
    border: 1px solid var(--whiteLight);
}

.btn-wrapper button.btn-small.only-icon-btn svg {
    width: 50px;
    height: 43px;
    fill: var(--whiteLight);
}

.main-card-header h4.MuiTypography-root {
    font-weight: 400;
}

/* Events Section */
.events-section {
    margin-top: 30px;
    padding: 20px;
    background-color: var(--darkGreen);
    border-radius: 10px;
    color: var(--white);
}

/* Title styling */
.events-section .title {
    font-weight: 400;
    color: var(--primeryColor);
    border-bottom: 2px solid var(--primeryColor); 
    padding-bottom: 5px; 
    text-align: left; 
    font-size: 24px;
}

/* Events Grid */
.events-grid {
    display: flex;
    align-items: center;
    padding: 15px;
    border-radius: 0px;
    background-color: #1f2937; 
    color: white;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    flex-wrap: wrap;
    gap: 20px;
}

/* Event Button */
.event-button {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(33.333% - 16px);
    min-width: 200px !important;
    border-radius: 30px !important;
    text-transform: none !important;
    font-size: 16px !important;
    padding: 16px !important;
    background-color: var(--darkGreen) !important; 
    color: var(--primeryColor) !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;
    border: 1px solid var(--primeryColor) !important;
    display: flex !important;
    align-items: center !important;
    text-align: left !important;
    justify-content: flex-start !important; 
    cursor: pointer !important;
    gap: 10px !important;
    /* width: "100%" !important; */
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    font-family: 'Maitree' !important;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2'),
         url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff');
}

/* Text within event box */
.event-button .event-text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex-grow: 1;
}

.event-button:hover {
    background-color: var(--primeryColor) !important; 
    color: var(--darkGreen) !important; 
}

/* allowing text to show up on boxes that have text overflow  */
/* .event-button:hover .event-text {
    white-space: normal; 
    overflow: visible; 
} */

/* so unfilled star only shows up when hovered over */
.event-button .unfilled-star {
    display: none;
}

.event-button:hover .unfilled-star {
    display: inline-flex;
    margin-right: 10px;
}

.additional-buttons {
    display: flex;
    flex-wrap: wrap; 
    gap: 10px;
    margin-top: 20px;
}

.additional-button {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(33.333% - 16px);
    min-width: 150px !important;
    padding: 10px !important;
    color: #ffffff !important;
    border-color: #64748b !important;
    font-size: 16px !important;
    text-transform: none !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;
}

.expand-button-container {
    display: flex;
    justify-content: flex-end;
    margin-top: 16px;
    width: 100%;
}

.expand-button {
    background-color: var(--darkGreen) !important;
    color: var(--primeryColor) !important;
    border-radius: 30px !important; 
    text-transform: none !important;
    margin-top: 20px !important;
    display: flex !important;
    justify-content: center !important;
}

.expand-button:hover {
    background-color: var(--primery) !important;
    color: var(--white) !important;
}
`, "",{"version":3,"sources":["webpack://./src/Screens/MyPatients/MyPatients.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,kCAAkC;AACtC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;IACV,mCAAmC;IACnC,gCAAgC;IAChC,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,gDAAgD;IAChD,oBAAoB;IACpB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,4BAA4B;IAC5B,mCAAmC;AACvC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;AACpB;;AAEA,mBAAmB;AACnB;IACI,gBAAgB;IAChB,aAAa;IACb,kCAAkC;IAClC,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA,kBAAkB;AAClB;IACI,gBAAgB;IAChB,0BAA0B;IAC1B,4CAA4C;IAC5C,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;AACnB;;AAEA,gBAAgB;AAChB;IACI,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,wCAAwC;IACxC,eAAe;IACf,SAAS;AACb;;AAEA,iBAAiB;AACjB;IACI,YAAyC;IAAzC,cAAyC;IAAzC,gCAAyC;IACzC,2BAA2B;IAC3B,8BAA8B;IAC9B,+BAA+B;IAC/B,0BAA0B;IAC1B,wBAAwB;IACxB,6CAA6C;IAC7C,qCAAqC;IACrC,mDAAmD;IACnD,gDAAgD;IAChD,wBAAwB;IACxB,8BAA8B;IAC9B,2BAA2B;IAC3B,sCAAsC;IACtC,0BAA0B;IAC1B,oBAAoB;IACpB,8BAA8B;IAC9B,8BAA8B;IAC9B,2BAA2B;IAC3B,kCAAkC;IAClC,iCAAiC;IACjC;+DACwE;AAC5E;;AAEA,0BAA0B;AAC1B;IACI,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,gDAAgD;IAChD,kCAAkC;AACtC;;AAEA,+DAA+D;AAC/D;;;GAGG;;AAEH,qDAAqD;AACrD;IACI,aAAa;AACjB;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,YAAyC;IAAzC,cAAyC;IAAzC,gCAAyC;IACzC,2BAA2B;IAC3B,wBAAwB;IACxB,yBAAyB;IACzB,gCAAgC;IAChC,0BAA0B;IAC1B,+BAA+B;IAC/B,mDAAmD;AACvD;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,6CAA6C;IAC7C,qCAAqC;IACrC,8BAA8B;IAC9B,+BAA+B;IAC/B,2BAA2B;IAC3B,wBAAwB;IACxB,kCAAkC;AACtC;;AAEA;IACI,2CAA2C;IAC3C,8BAA8B;AAClC","sourcesContent":[".my-patients-container {\n    display: flex;\n    background-color: var(--darkGreen);\n}\n\n.my-patients-container .my-patients-left-section {\n    width: 15%;\n}\n\n.my-patients-container .my-patients-right-section {\n    width: 85%;\n    background-color: var(--lightBlack);\n    border-radius: 20px 0px 0px 20px;\n    padding: 23px 34px;\n}\n\n.my-patients-topbar {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    flex-wrap: wrap;\n    border-bottom: 1px solid rgb(255, 255, 255, 50%);\n    padding-bottom: 12px;\n    gap: 0.5rem;\n}\n\n.my-patients-topbar .title {\n    font-weight: 400;\n    color: var(--primeryColor);\n}\n\n.my-patients-topbar .right {\n    display: flex;\n    align-items: center;\n    margin-left: auto;\n}\n\n.list-icon {\n    margin-left: 19px;\n}\n\n.btn-wrapper button.btn-small.only-icon-btn {\n    padding: 0;\n    background: var(--darkGreen);\n    border: 1px solid var(--whiteLight);\n}\n\n.btn-wrapper button.btn-small.only-icon-btn svg {\n    width: 50px;\n    height: 43px;\n    fill: var(--whiteLight);\n}\n\n.main-card-header h4.MuiTypography-root {\n    font-weight: 400;\n}\n\n/* Events Section */\n.events-section {\n    margin-top: 30px;\n    padding: 20px;\n    background-color: var(--darkGreen);\n    border-radius: 10px;\n    color: var(--white);\n}\n\n/* Title styling */\n.events-section .title {\n    font-weight: 400;\n    color: var(--primeryColor);\n    border-bottom: 2px solid var(--primeryColor); \n    padding-bottom: 5px; \n    text-align: left; \n    font-size: 24px;\n}\n\n/* Events Grid */\n.events-grid {\n    display: flex;\n    align-items: center;\n    padding: 15px;\n    border-radius: 0px;\n    background-color: #1f2937; \n    color: white;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    flex-wrap: wrap;\n    gap: 20px;\n}\n\n/* Event Button */\n.event-button {\n    flex: 1 1 calc(33.333% - 16px) !important;\n    min-width: 200px !important;\n    border-radius: 30px !important;\n    text-transform: none !important;\n    font-size: 16px !important;\n    padding: 16px !important;\n    background-color: var(--darkGreen) !important; \n    color: var(--primeryColor) !important;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;\n    border: 1px solid var(--primeryColor) !important;\n    display: flex !important;\n    align-items: center !important;\n    text-align: left !important;\n    justify-content: flex-start !important; \n    cursor: pointer !important;\n    gap: 10px !important;\n    /* width: \"100%\" !important; */\n    white-space: nowrap !important;\n    overflow: hidden !important;\n    text-overflow: ellipsis !important;\n    font-family: 'Maitree' !important;\n    src: url('../../Assets/font/Maitree/Maitree-Medium.woff2') format('woff2'),\n         url('../../Assets/font/Maitree/Maitree-Medium.woff') format('woff');\n}\n\n/* Text within event box */\n.event-button .event-text {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    flex-grow: 1;\n}\n\n.event-button:hover {\n    background-color: var(--primeryColor) !important; \n    color: var(--darkGreen) !important; \n}\n\n/* allowing text to show up on boxes that have text overflow  */\n/* .event-button:hover .event-text {\n    white-space: normal; \n    overflow: visible; \n} */\n\n/* so unfilled star only shows up when hovered over */\n.event-button .unfilled-star {\n    display: none;\n}\n\n.event-button:hover .unfilled-star {\n    display: inline-flex;\n    margin-right: 10px;\n}\n\n.additional-buttons {\n    display: flex;\n    flex-wrap: wrap; \n    gap: 10px;\n    margin-top: 20px;\n}\n\n.additional-button {\n    flex: 1 1 calc(33.333% - 16px) !important;\n    min-width: 150px !important;\n    padding: 10px !important;\n    color: #ffffff !important;\n    border-color: #64748b !important;\n    font-size: 16px !important;\n    text-transform: none !important;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;\n}\n\n.expand-button-container {\n    display: flex;\n    justify-content: flex-end;\n    margin-top: 16px;\n    width: 100%;\n}\n\n.expand-button {\n    background-color: var(--darkGreen) !important;\n    color: var(--primeryColor) !important;\n    border-radius: 30px !important; \n    text-transform: none !important;\n    margin-top: 20px !important;\n    display: flex !important;\n    justify-content: center !important;\n}\n\n.expand-button:hover {\n    background-color: var(--primery) !important;\n    color: var(--white) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
